import axios from "axios";
import { api } from "~/router/apiConfig";

export function index() {
  return axios.get(api.path("userReferralProgram.index"), null);
}
